export default __webpack_public_path__ + "static/media/toolbar-ordered.1fb80012.svg";